import React from "react";
import Title from "./Title";
import { useTranslation } from "react-i18next";
import json from "../languages/de/translation.json";

export default function Imprint() {
  const { t } = useTranslation();

  return (
    <section id={t("imprint")} className="imprint-section">
      <div className="imprint-bg background-img">
        <Title title={t("imprint")} />
      </div>
      <h3 className="margin-top-l">{t("imprint-address-title")}</h3>
      <div style={{ whiteSpace: "pre-line" }}>
        <p>{json["imprint-address-text"]}</p>
      </div>
      <h3 className="margin-top-l">{t("contact-title")}</h3>
      <p>
        {t("email")} <a href="mailto:violaprinz@web.de">violaprinz@web.de</a>
      </p>
      <p>
        {t("telephone")} <a href="tel:+4915227583299">01522 7583299</a>
      </p>
      <h3 className="margin-top-l">{t("imprint-taxnumber")}</h3>
      <div style={{ whiteSpace: "pre-line" }}>
        <p>{json["imprint-taxnumber-text"]}</p>
      </div>
      <h3 className="margin-top-l">{t("imprint-profession")}</h3>
      <div style={{ whiteSpace: "pre-line" }}>
        <p>{json["imprint-profession-text"]} </p>
      </div>
      <h3 className="margin-top-l">{t("imprint-dispute-settlement-title")}</h3>
      <p>
        {t("imprint-dispute-settlement-text")}{" "}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noreferrer"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
      </p>
      <h3 className="margin-top-l">
        {t("imprint-consumer-dispute-regulation-title")}
      </h3>
      <p>{t("imprint-consumer-dispute-regulation-text")}</p>
      <h3 className="margin-top-l">{t("image-licenses")}</h3>
      <p>
        Image Hibiskus Flower by{" "}
        <a
          href="https://pixabay.com/users/annikalepp-13989167/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=7586222"
          target="_blank"
          rel="noreferrer"
        >
          Annika Lepp
        </a>{" "}
        from{" "}
        <a
          href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=7586222"
          target="_blank"
          rel="noreferrer"
        >
          Pixabay
        </a>
      </p>
      <p>
        Image Kolibri by{" "}
        <a
          href="https://pixabay.com/users/veronika_andrews-16688553/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=5837675"
          target="_blank"
          rel="noreferrer"
        >
          Veronika Andrews
        </a>{" "}
        from{" "}
        <a
          href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=5837675"
          target="_blank"
          rel="noreferrer"
        >
          Pixabay
        </a>
      </p>
    </section>
  );
}
